import Inn_img1 from "../../../assets/images/commalax-landing/innisfree/img-01.png";
import Inn_img2 from "../../../assets/images/commalax-landing/innisfree/img-02.png";
import Inn_img3 from "../../../assets/images/commalax-landing/innisfree/img-03.png";
import Inn_img4 from "../../../assets/images/commalax-landing/innisfree/img-04.png";
import Inn_img5 from "../../../assets/images/commalax-landing/innisfree/img-05.png";
import Inn_img7 from "../../../assets/images/commalax-landing/innisfree/img-07.png";

import cell_img1 from "../../../assets/images/commalax-landing/celluver/img-01.png";
import cell_img2 from "../../../assets/images/commalax-landing/celluver/img-02.png";
import cell_img3 from "../../../assets/images/commalax-landing/celluver/img-03.png";
import cell_img4 from "../../../assets/images/commalax-landing/celluver/img-04.png";
import cell_img5 from "../../../assets/images/commalax-landing/celluver/img-05.png";
import cell_img6 from "../../../assets/images/commalax-landing/celluver/img-06.png";
import cell_img7 from "../../../assets/images/commalax-landing/celluver/img-07.png";

import logo01 from "../../../assets/images/commalax-landing/brands/img01.png";
import logo02 from "../../../assets/images/commalax-landing/brands/img02.png";
import logo03 from "../../../assets/images/commalax-landing/brands/img03.png";
import logo04 from "../../../assets/images/commalax-landing/brands/img04.png";
import logo05 from "../../../assets/images/commalax-landing/brands/img05.png";
import logo06 from "../../../assets/images/commalax-landing/brands/img06.png";
import logo07 from "../../../assets/images/commalax-landing/brands/img07.png";
import logo08 from "../../../assets/images/commalax-landing/brands/img08.png";
import logo09 from "../../../assets/images/commalax-landing/brands/img09.png";
import logo10 from "../../../assets/images/commalax-landing/brands/img10.png";
import logo11 from "../../../assets/images/commalax-landing/brands/img11.png";
import logo12 from "../../../assets/images/commalax-landing/brands/img12.png";
import logo13 from "../../../assets/images/commalax-landing/brands/img13.png";
import logo14 from "../../../assets/images/commalax-landing/brands/img14.png";
import logo15 from "../../../assets/images/commalax-landing/brands/img15.png";
import logo16 from "../../../assets/images/commalax-landing/brands/img16.png";
import logo17 from "../../../assets/images/commalax-landing/brands/img17.png";
import logo18 from "../../../assets/images/commalax-landing/brands/img18.png";
import logo19 from "../../../assets/images/commalax-landing/brands/img19.png";
import logo20 from "../../../assets/images/commalax-landing/brands/img20.png";
import logo21 from "../../../assets/images/commalax-landing/brands/img21.png";
import logo22 from "../../../assets/images/commalax-landing/brands/img22.png";
import logo23 from "../../../assets/images/commalax-landing/brands/img23.png";
import logo24 from "../../../assets/images/commalax-landing/brands/img24.png";
import logo25 from "../../../assets/images/commalax-landing/brands/img25.png";
import logo26 from "../../../assets/images/commalax-landing/brands/img26.png";
import logo27 from "../../../assets/images/commalax-landing/brands/img27.png";
import logo28 from "../../../assets/images/commalax-landing/brands/img28.png";
import logo29 from "../../../assets/images/commalax-landing/brands/img29.png";
export const Brands = [
  {
    name: "Innisfree",
    description: "",
    products: [
      {
        img: Inn_img1,
        price: 20000,
        description: "Innisfree Intensive Triple Shield Sunscreen",
        link: "https://commalax.com/product/cluqhb0zw4125401s6iieuklv6",
      },
      {
        img: Inn_img2,
        price: 26000,
        description: "INNIS FREE NO SEBUM MINERAL PACT",
        link: "https://commalax.com/product/clglzap295729701s6huhyajei",
      },
      {
        img: Inn_img3,
        price: 28000,
        description: "Innisfree Jeju Volcanic Pore Toner 2XL 200 ml",
        link: "https://commalax.com/product/clgxcz1511687501s66m5sj3uk",
      },
      {
        img: Inn_img4,
        price: 16500,
        description: "Jeju Trouble Facial Foam 150 g",
        link: "https://commalax.com/product/cliy7gauf434201s6vziwya4o",
      },
      {
        img: Inn_img5,
        price: 13500,
        description: "Innisfree Green Tea Cleansing Foam",
        link: "https://commalax.com/product/clugeoehf1861001s6tkzyyg28",
      },
      {
        img: Inn_img7,
        price: 14000,
        description: "Innisfree Jeju Bija Trouble Facial Foam150g",
        link: "https://commalax.com/product/clugetikt2908401s6toi4t0iu",
      },
    ],
  },
  {
    name: "CELLUVER",
    description: "",
    products: [
      {
        img: cell_img1,
        price: 25000,
        description: "Celluver Chiffon Perfume 1997 Chloe",
        link: "https://commalax.com/product/clr62becs662001s64b7h9w3q",
      },
      {
        img: cell_img2,
        price: 19000,
        description: "Celluver Fabric Perfume",
        link: "https://commalax.com/product/cls9t723q1290501s6jlv0fhbc",
      },
      {
        img: cell_img3,
        price: 29600,
        description: "Celluver Homme Pocket Soft Attitude And Cotton",
        link: "https://commalax.com/product/clggekxeb5362901s66gshnjlw",
      },
      {
        img: cell_img4,
        price: 52200,
        description: "Celluver Triple Black Perfume Shampoo",
        link: "https://commalax.com/product/cls9tlcbn1716701s6257y7b82",
      },
      {
        img: cell_img5,
        price: 48800,
        description: "Celluver Protein LPP Perfume Treatment Hair mask (250ml)",
        link: "https://commalax.com/product/cls9ukt9e757501s6j1cxthwm",
      },
      {
        img: cell_img6,
        price: 23000,
        description: "Celluver Water Glow Hair Serum",
        link: "https://commalax.com/product/cls42fjna1162501s68cdae8ws",
      },
      {
        img: cell_img7,
        price: 29600,
        description: "Innisfree Jeju Bija Trouble Facial Foam150g",
        link: "https://commalax.com/product/cls9s4sdf4488901s6xp7t331w",
      },
    ],
  },
];

export const brandLogos = [
  logo01,
  logo02,
  logo03,
  logo04,
  logo05,
  logo06,
  logo07,
  logo08,
  logo09,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
  logo20,
  logo21,
  logo22,
  logo23,
  logo24,
  logo25,
  logo26,
  logo27,
  logo28,
  logo29,
];
